import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=240dfc3a&scoped=true&"
import script from "./GeneralSetting.vue?vue&type=script&lang=ts&"
export * from "./GeneralSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSetting.vue?vue&type=style&index=0&id=240dfc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240dfc3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VSnackbar})
